var view = view || {};
var events = events || {};
var windowObj = new Object;



if ( typeof Shopify === 'undefined') Shopify = {};

Shopify.formatMoney = Shopify.formatMoney || function( cents, format = '${{amount}}' ) {
	
	// simple formatter: converts cents to dollars
	
	const dollars = (cents / 100).toFixed(2);
	
	return format.replace('{{amount}}', dollars);

};



/*
 * View
 */


view.init = function() {
	
	view.resizeWindow();
	
}

view.resizeWindow = function() {
	
	windowObj.w = window.innerWidth;
	
	windowObj.h = window.innerHeight;
	
}



/*
 * Events
 */

events.init = function() {
	
	// resizer
	window.addEventListener( "resize", view.resizeWindow );
	
	// add to cart event
	events.addToCart();
	
	// render minicart
	events.initMiniCart();
	
	// see if there are items in the cart and add to minicart
	events.updateMiniCart();
	
}

// add to cart
events.addToCart = function() {
	
	const forms = document.querySelectorAll( '.ajax-product-form' );
	
	forms.forEach( form => {
		
		form.addEventListener( 'submit', e => {
		
			e.preventDefault(); 
			
			const formData = new FormData( form );
			
			const url = '/cart/add.js';
			
			fetch( url, {
				method: 'POST',
				body: formData,
				headers: {
					'Accept': 'application/json'
				}
			})
			.then(res => res.json())
			.then(data => {
				
				console.log( 'Added to cart', data );
				
				const feedback = form.parentElement.querySelector( '.ajax-cart-feedback' );
				
				if ( feedback ) {
					
					feedback.style.display = 'block';
					
					setTimeout(() => { feedback.style.display = 'none'; }, 2000 );
					
				}
				
				// Update mini-cart count
				const cartCountEls = document.querySelectorAll( '.header__utils sup' );
				
				cartCountEls.forEach(el => {
					
					el.textContent = data.quantity || 1;
					
				});
				
				//  Refresh mini-cart contents (without opening)
				events.updateMiniCart();
				
			})
			.catch(err => console.error( 'Error adding to cart:', err ));
		
		});
		
	});
	
}

// init minicart
events.initMiniCart = function() {
	
	const miniCart = document.getElementById( 'mini-cart' );
	const closeBtn = miniCart.querySelector( '.mini-cart__close' );
	const overlay = miniCart.querySelector( '.mini-cart__overlay' );
	const bagIcon = document.querySelector( '.header__utils .bag' ); // adjust selector
	
	// open mini-cart
	if ( bagIcon ) {
		
		bagIcon.addEventListener( 'click', e => {
			
			e.preventDefault();
			
			miniCart.classList.add( 'active' );
			
			miniCart.setAttribute( 'aria-hidden', 'false' );
			
		});
		
	}
	
	// close mini-cart
	[overlay, closeBtn].forEach(el => {
		
		el.addEventListener( 'click', () => {
			
			miniCart.classList.remove( 'active' );
			
			miniCart.setAttribute( 'aria-hidden', 'true' );
			
		});
		
	});
	
	// qty events
	miniCart.addEventListener( 'click', e => {
		
		const itemEl = e.target.closest('.mini-cart__item');
		
		if ( !itemEl ) return;
		
		const key = itemEl.dataset.key;
		
		if ( e.target.classList.contains( 'mini-cart__qty-minus' ) ) {
			
			events.updateCartItem( key, parseInt( itemEl.querySelector('.mini-cart__qty-number').textContent ) - 1 );
			
		}
		
		if ( e.target.classList.contains( 'mini-cart__qty-plus' ) ) {
			
			events.updateCartItem( key, parseInt(itemEl.querySelector( '.mini-cart__qty-number').textContent ) + 1 );
			
		}
		
	});
	
};

// update mini cart
events.updateMiniCart = function() {
	
	const miniCart = document.getElementById( 'mini-cart' ); // your container
	
	const miniCartItems = document.querySelector( '.mini-cart__items' );
	
	const miniCartSubtotal = document.querySelector( '.mini-cart__subtotal-amount' );
	
	if (!miniCart || !miniCartItems || !miniCartSubtotal) return;
	
	
	// Add loading class
	miniCart.classList.add( 'loading' );
	
	fetch('/cart.js')
		.then(res => res.json())
		.then(cart => {
			
			miniCartItems.innerHTML = cart.items.map(item => `
				<div class="mini-cart__item" data-key="${item.key}">
					<img src="${item.image}" alt="${item.title}" width="60" height="60">
					<div class="mini-cart__item-info">
						<p>${item.product_title}</p>
						<p>${Shopify.formatMoney(item.price)}</p>
						<div class="mini-cart__qty">
							<button class="mini-cart__qty-minus">−</button>
							<span class="mini-cart__qty-number">${item.quantity}</span>
							<button class="mini-cart__qty-plus">+</button>
						</div>
					</div>
				</div>
			`).join('');
			
			// Update header count
			const cartCountEls = document.querySelectorAll( '.header__icons sup' );
			
			cartCountEls.forEach(el => el.textContent = cart.item_count);
			
			// Update subtotal
			miniCartSubtotal.textContent = Shopify.formatMoney(cart.items_subtotal_price);
		
	})
	.catch( err => console.error( 'Error fetching cart:', err ) )
	.finally( () => {
		
		// Remove loading class regardless of success/error
		miniCart.classList.remove( 'loading' );
		
	});
	
};

// update cart items (qty)
events.updateCartItem = function( key, quantity ) {
	
	fetch('/cart/change.js', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
		body: JSON.stringify({ id: key, quantity: quantity })
	})
	.then( res => res.json() )
	.then( cart => {
		
		// Refresh mini-cart
		events.updateMiniCart();
		
	})
	.catch(err => console.error( 'Error updating cart:', err ) );
	
}



document.addEventListener( 'DOMContentLoaded', () => {
	
	view.init();
	
	// events.init();
	
} );